// Mock data for Assure FM Services website

export const companyStats = {
  customersServed: '200+',
  projectsDone: '500+',
  awardsWon: '10+',
  expertWorkers: '500+'
};

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    position: 'Facility Manager, Tech Corp India',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop',
    rating: 5,
    text: 'Assure FM Services has transformed our facility operations. Their 24/7 support and professional team have been exceptional. Highly recommended!'
  },
  {
    id: 2,
    name: 'Priya Sharma',
    position: 'Operations Head, Manufacturing Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
    rating: 5,
    text: 'Outstanding service quality and reliability. The team is responsive, professional, and always goes the extra mile to ensure smooth operations.'
  },
  {
    id: 3,
    name: 'Amit Patel',
    position: 'General Manager, Retail Chain',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop',
    rating: 5,
    text: 'Three decades of expertise really shows. From housekeeping to security, every service is delivered with precision and care.'
  },
  {
    id: 4,
    name: 'Sneha Reddy',
    position: 'Director, Corporate Services',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop',
    rating: 5,
    text: 'Single-point accountability and comprehensive facility management solutions have made our operations seamless. Excellent partner!'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: '5 Essential Facility Management Trends for 2025',
    excerpt: 'Discover the latest trends shaping the facility management industry and how they can benefit your business operations.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=400&fit=crop',
    category: 'Industry Insights',
    date: '2025-01-10',
    author: 'Assure FM Team'
  },
  {
    id: 2,
    title: 'The Importance of Preventive Maintenance in Facility Management',
    excerpt: 'Learn how preventive maintenance can save costs, improve safety, and extend the lifecycle of your facility assets.',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&h=400&fit=crop',
    category: 'Best Practices',
    date: '2025-01-05',
    author: 'Technical Team'
  },
  {
    id: 3,
    title: 'Sustainable Facility Management: Going Green in 2025',
    excerpt: 'Explore eco-friendly practices and sustainable solutions that reduce environmental impact while maintaining operational excellence.',
    image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=800&h=400&fit=crop',
    category: 'Sustainability',
    date: '2024-12-28',
    author: 'Environment Team'
  }
];

export const services = [
  {
    id: 1,
    title: 'Technical & Infrastructure Management',
    description: 'Reliable technical upkeep for smooth operations.',
    fullDescription: 'Comprehensive MEP (Mechanical, Electrical, Plumbing) services ensuring your infrastructure operates at peak efficiency. Our expert technicians provide preventive maintenance, emergency repairs, and system optimization.',
    icon: 'Settings',
    image: 'https://images.unsplash.com/photo-1595856898575-9d187bd32fd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtYWludGVuYW5jZSUyMHdvcmtlcnxlbnwwfHx8fDE3NjA0OTM1NjR8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    title: 'Workplace Support & Housekeeping',
    description: 'Clean, safe, and efficient workspaces.',
    fullDescription: 'Professional housekeeping and workplace support services that create a healthy, productive environment. Our trained staff ensures cleanliness, hygiene, and a positive impression for your employees and visitors.',
    icon: 'Sparkles',
    image: 'https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjbGVhbmluZyUyMHNlcnZpY2V8ZW58MHx8fHwxNzYwNDkzNTcxfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    title: 'Security & Risk Management',
    description: 'Robust safety and security solutions.',
    fullDescription: 'Comprehensive security services including trained security personnel, access control, surveillance, and risk assessment. We ensure the safety of your people, assets, and property 24/7.',
    icon: 'Shield',
    image: 'https://images.unsplash.com/photo-1694521787193-9293daeddbaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxmYWNpbGl0eSUyMG1hbmFnZW1lbnR8ZW58MHx8fHwxNzYwNDkzNTUxfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    title: 'Workforce & Staffing Solutions',
    description: 'Trained staff tailored to your business needs.',
    fullDescription: 'Flexible staffing solutions with trained professionals who integrate seamlessly into your operations. From administrative support to technical specialists, we provide the right talent for your requirements.',
    icon: 'Users',
    image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxtYWludGVuYW5jZSUyMHdvcmtlcnxlbnwwfHx8fDE3NjA0OTM1NjR8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 5,
    title: 'Landscaping & Environment Management',
    description: 'Sustainable, well-maintained outdoor spaces.',
    fullDescription: 'Professional landscaping and environmental management services that enhance your property aesthetics while promoting sustainability. From regular maintenance to seasonal care and eco-friendly practices.',
    icon: 'Trees',
    image: 'https://images.unsplash.com/photo-1606836379799-f88b03bc7039?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxmYWNpbGl0eSUyMG1hbmFnZW1lbnR8ZW58MHx8fHwxNzYwNDkzNTUxfDA&ixlib=rb-4.1.0&q=85'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: '24/7 Operational Excellence',
    description: 'Round-the-clock support ensuring your facility operations never stop.',
    icon: 'Clock'
  },
  {
    id: 2,
    title: 'Single-Point Accountability',
    description: 'One partner for all your facility management needs, simplifying coordination.',
    icon: 'Target'
  },
  {
    id: 3,
    title: 'Value-Added Services',
    description: 'Beyond basic FM, we deliver strategic solutions that add measurable value.',
    icon: 'TrendingUp'
  },
  {
    id: 4,
    title: 'Efficiency & Safety Focus',
    description: 'Processes designed for maximum efficiency while maintaining highest safety standards.',
    icon: 'CheckCircle'
  },
  {
    id: 5,
    title: 'Compliance Assurance',
    description: 'Full regulatory compliance ensuring you meet all industry standards.',
    icon: 'FileCheck'
  },
  {
    id: 6,
    title: 'Long-Term Value',
    description: 'Strategic partnerships focused on sustainable, long-term operational excellence.',
    icon: 'Award'
  }
];

